import styled from "styled-components";

export const DesignatorBox = styled.div`
  font-size: ${props => props.theme.fontSize.h4};
`
